export default {
    "getProducts": "1fa2ff86db1a1ff608f98a12cb9b9fb6d00477aeda08393d6d79752e6a2a42cb",
    "getCategoryProducts": "455c53870ca853aded0f53d8a06855ca7f7bca9c3676727c4c5104fd8dc1c28b",
    "getProductsOfTheWeek": "f3b98a9d39bd2621bcb0329c88628bd8daf2dafe1d839f28349ba8d756fe3324",
    "getRecommendedProducts": "e7d42acc05f7386d66901a9634815968b3bc21ca6b93fcded73ee3218e3d3203",
    "getProductsOnSale": "9659f7e3426b249ac510bc0fe00499c64632f6855ccbfdc4d0d17f132316302e",
    "getBestsellerProducts": "ccb04e414971a443715ce938384619801705dfdd26c7275ff1b1db487e7f43af"
};
